/**
 * Lined sheets for a student who does not write on the question paper (bug fix 1, spec 8):
 * a name line, then a header and room for each question that needs writing — three marks or
 * more — and the paper's tag on every page, so a pile of handwritten answers goes back to its
 * paper and its scheme. Drawn from the paper already loaded; print only.
 */
import { questionMarks } from "./marks";
import { CoverTag, type PaperIdentity } from "./PrintTag";
import type { Paper } from "./types";

export const NEEDS_WRITING = 3;

export function writtenQuestions(paper: Paper): { number: number; marks: number }[] {
  return paper.questions
    .map((q) => ({ number: q.number, marks: questionMarks(q) }))
    .filter((q) => q.marks >= NEEDS_WRITING);
}

export function AnswerSheets({ paper, identity }: { paper: Paper; identity: PaperIdentity }) {
  return (
    <section className="answer-sheets" aria-label="Answer sheets" data-testid="answer-sheets">
      <CoverTag identity={identity} kind="Answer sheet" />
      <div className="answer-sheets__name">
        Name <span className="answer-sheets__blank" />
      </div>
      {writtenQuestions(paper).map((q) => (
        <div key={q.number} className="answer-sheets__question">
          <div className="answer-sheets__head">
            Question {q.number} ({q.marks} marks)
          </div>
          <div className="answer-lines" aria-hidden="true">
            {Array.from({ length: Math.max(6, q.marks * 3) }, (_, i) => (
              <div className="answer-lines__line" key={i} />
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
